<script>
import { mapState } from "vuex";

export default {
	name: "compKrismaDetail",
	data() {
		return {};
	},
	computed: {
		isLoading() {
			return this.$store.state.isLoading;
		},
		...mapState({
			umatKrismaItem: (state) => state.umatKrisma.item,
		}),
	},
};
</script>

<template>
	<table class="table table-striped table-hover text-left">
		<tbody>
			<tr>
				<td>No Buku LC</td>
				<td>:</td>
				<td>{{ umatKrismaItem.no_buku_lc }}</td>
			</tr>
			<tr>
				<td>No LC</td>
				<td>:</td>
				<td>{{ umatKrismaItem.no_lc }}</td>
			</tr>
			<tr>
				<td>Tanggal Krisma</td>
				<td>:</td>
				<td>{{ umatKrismaItem.tgl_krisma_human }}</td>
			</tr>
			<tr>
				<td>Pemberi Krisma</td>
				<td>:</td>
				<td>{{ umatKrismaItem.pemberi_krisma }}</td>
			</tr>			
         <tr>
				<td>Wali I</td>
				<td>:</td>
				<td>{{ umatKrismaItem.wali1 }}</td>
			</tr>			
         <tr>
				<td>Wali II</td>
				<td>:</td>
				<td>{{ umatKrismaItem.wali2 }}</td>
			</tr>
			<tr>
				<td>Keuskupan LC</td>
				<td>:</td>
				<td>{{ umatKrismaItem.keuskupan_lc }}</td>
			</tr>
			<tr>
				<td>Paroki LC</td>
				<td>:</td>
				<td>{{ umatKrismaItem.paroki_lc }}</td>
			</tr>
		</tbody>
	</table>
</template>

